<template>
  <v-dialog
    v-model="display"
    persistent
    width="500"
  >
    <v-card class="delete-user">
      <v-row>
        <v-col cols="12" class="center">
          <h3>Delete User</h3>
        </v-col>
      </v-row>
      <v-row  
        align="center"
        justify="center"
        class="padding-top"
      >
        <v-col cols="3" class="d-flex justify-center">
          <v-icon 
            color="red"
            size="50"
          >
            mdi-alert
          </v-icon>
        </v-col>

        <v-col class="d-flex justify-center">
        <span>The user <span class="bold">{{ user.email }}</span> will be permanently deleted. Are you sure you want to proceed?</span>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" class="center">
          Enter 'delete' below to confirm.
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="confirmationInput"
          />
        </v-col>
      </v-row>

      <v-row  
        align="center"
        justify="center"
        class="padding-bottom reboot-actions"
      >
        <v-btn
          color="red" 
          text
          @click="close"
        >
          cancel
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn 
          v-if="!deleting"
          :disabled="userConfirmation"
          color="green"
          text
          @click="deleteUser"
        >
          delete
        </v-btn>
        <v-progress-circular
          v-else
          indeterminate
          color="primary"
        ></v-progress-circular>
        <br>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>

import { Logger } from "aws-amplify"
const logger = new Logger("Delete User")

import { deleteOrgUser } from "@/services/API.js"

import { AmplifyEventBus } from "aws-amplify-vue";

export default {
  name: 'DeleteUser',
  props: {
    display: {
      required: true,
      type: Boolean
    },
    user: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      confirmationInput: '',
      deleting: false
    }
  },  
  computed: {
    userConfirmation() {
      return this.confirmationInput.toLowerCase() == 'delete' ? false : true;
    },
  },  
  methods: {
    async deleteUser() {
      this.deleting = true;

      const res = await deleteOrgUser(this.user.Org.id, this.user.id)

      if (res) {
        this.deleting = false;

        this.$emit('deleteUser', this.user.id)
        this.$emit('close')
        AmplifyEventBus.$emit("snackEvent", {color: "green", text: "User deleted."})
        logger.info('success ', res)
      }
      else {
        this.deleting = false;
        AmplifyEventBus.$emit("snackEvent", {color: "red", text: "An error occurred."})
        logger.info('fail ', res)
      }
    },

    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
  .delete-user {
    padding: 1.5em;

    h3 {
      color: #F44336 !important;
    }
    .bold {
      font-weight: bold;
    }
  }
  .center {
    text-align: center;
  }
</style>